var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.43266C0.5 0.641875 1.16203 0 1.97812 0H19.0219C19.8383 0 20.5 0.641875 20.5 1.43266V18.5676C20.5 19.3586 19.8383 20 19.0219 20H1.97812C1.16211 20 0.5 19.3587 0.5 18.5678V1.43242V1.43266Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57742 16.7374V7.73338H3.58461V16.7374H6.57773H6.57742ZM5.08164 6.50424C6.12508 6.50424 6.77469 5.81284 6.77469 4.94877C6.75516 4.06502 6.12508 3.39291 5.10148 3.39291C4.07719 3.39291 3.4082 4.06502 3.4082 4.94869C3.4082 5.81276 4.05758 6.50416 5.06203 6.50416H5.08141L5.08164 6.50424ZM8.23398 16.7374H11.2266V11.7097C11.2266 11.441 11.2461 11.1715 11.3252 10.9796C11.5414 10.4417 12.0338 9.88487 12.8608 9.88487C13.9434 9.88487 14.3768 10.7105 14.3768 11.921V16.7374H17.3693V11.5748C17.3693 8.80924 15.893 7.52229 13.9241 7.52229C12.3098 7.52229 11.6008 8.42455 11.2069 9.03909H11.2268V7.7337H8.23414C8.2732 8.57838 8.23391 16.7378 8.23391 16.7378L8.23398 16.7374Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/linkedInIcon.a2fa4fecdf3a3b8a6919df661139c591.svg";
export { ForwardRef as ReactComponent };